// removed by extract-text-webpack-plugin
module.exports = {"white":"src-components-modules-Cta-CtaDefault-style----bgColor-module---white---2u_Q7 bg-white","blue":"src-components-modules-Cta-CtaDefault-style----bgColor-module---blue---2kuWj bg-marvel","darkSnow":"src-components-modules-Cta-CtaDefault-style----bgColor-module---darkSnow---2I2is bg-snow--d","snow":"src-components-modules-Cta-CtaDefault-style----bgColor-module---snow---1Jn5Y bg-snow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Cta/CtaDefault/style/bgColor.module.css
// module id = 1443
// module chunks = 168707334958949